module.exports = i => String.fromCharCode('A'.charCodeAt(0) + i);

